import { render, staticRenderFns } from "./MSTeamsLoading.vue?vue&type=template&id=2e4083d6&scoped=true&"
import script from "./MSTeamsLoading.vue?vue&type=script&lang=js&"
export * from "./MSTeamsLoading.vue?vue&type=script&lang=js&"
import style0 from "./MSTeamsLoading.vue?vue&type=style&index=0&id=2e4083d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4083d6",
  null
  
)

export default component.exports